import React from 'react';
import PropTypes from 'prop-types';

const SearchResult = ({
	children,
	path,
	count = null,
	active = false,
	onMouseOver = () => {},
	onMouseOut = () => {},
	onClick = () => {}
}) => {
	const optionalAttributes = {};
	if (onMouseOver) {
		optionalAttributes.onMouseOver = onMouseOver;
		optionalAttributes.onFocus = onMouseOver;
	}
	if (onMouseOut) {
		optionalAttributes.onMouseOut = onMouseOut;
		optionalAttributes.onBlur = onMouseOut;
	}

	return (
		<li>
			<a
				href={path}
				className={`list-group-item ${active ? 'selected' : ''}`}
				onClick={onClick}
				{...optionalAttributes}
			>
				{children}{' '}
				{count && <small className="text-muted">{count}</small>}
			</a>
		</li>
	);
};

SearchResult.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
		PropTypes.string
	]).isRequired,
	path: PropTypes.string.isRequired,
	count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	active: PropTypes.bool,
	onMouseOver: PropTypes.func,
	onMouseOut: PropTypes.func,
	onClick: PropTypes.func
};

export default SearchResult;
